import type { UserInfo } from "@memorang/types";

const fetchUserInfo = async (
	email: string,
	_appId: string,
): Promise<UserInfo> => {
	return {
		id: "",
		email,
		isOnboarded: false,
	};
};

export default fetchUserInfo;
